export default __webpack_public_path__ + "locales/cs/EmptyTrashDialog.json?hash=842d8dee18e6cfeba53edb6153655698";